export const OPERATION_CONTROL_NUMBER_SPLIT_INDEX = 10;

export interface OperationControlNumberLines {
  primary: string;
  secondary: string;
}

export function splitOperationControlNumber(value: string): OperationControlNumberLines {
  const normalized = value.trim();

  if (normalized.length <= OPERATION_CONTROL_NUMBER_SPLIT_INDEX) {
    return { primary: normalized, secondary: '' };
  }

  return {
    primary: normalized.slice(0, OPERATION_CONTROL_NUMBER_SPLIT_INDEX),
    secondary: normalized.slice(OPERATION_CONTROL_NUMBER_SPLIT_INDEX),
  };
}

export function getCarbonCreditCodeValue(code?: string | null): string {
  return code?.trim() || '';
}
